import { render, staticRenderFns } from "./BDjh.vue?vue&type=template&id=6056e242"
import script from "./BDjh.vue?vue&type=script&lang=js"
export * from "./BDjh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports